import { Box, Typography, useTheme } from '@mui/material';
import { TimeOptionType } from '../../types';

import { StyledBoxIcon } from '../timeframe-bar-options/components/time-box-option/style';
import { ArrowDownIconSmall } from 'src/assets/icons/common/ArrowDownIconSmall';
import { CustomOptionDateIcon } from 'src/assets/icons/CustomOptionDateIcon';
import { OneDayRangeIcon } from 'src/assets/icons/OneDayRangeIcon';
import { OneMonthRangeIcon } from 'src/assets/icons/OneMonthRangeIcon';
import { SenvenDaysRangeIcon } from 'src/assets/icons/SenvenDaysRangeIcon';

type Props = {
  selectedTimeOption: TimeOptionType;
  onClick: (event: React.MouseEvent<HTMLDivElement>) => void;
};

export const SelectedTimeframeOption = ({ selectedTimeOption, onClick }: Props) => {
  const theme = useTheme();
  const mainColor = theme.palette.primary.main;

  const renderIcon = () => {
    if (selectedTimeOption === '5m') return <OneDayRangeIcon fill={mainColor} />;
    if (selectedTimeOption === '1h') return <OneDayRangeIcon fill={mainColor} />;
    if (selectedTimeOption === '3h') return <OneDayRangeIcon fill={mainColor} />;
    if (selectedTimeOption === '6h') return <OneDayRangeIcon fill={mainColor} />;
    if (selectedTimeOption === '1d') return <OneDayRangeIcon fill={mainColor} />;
    if (selectedTimeOption === '7d') return <SenvenDaysRangeIcon fill={mainColor} />;
    if (selectedTimeOption === '30d') return <OneMonthRangeIcon fill={mainColor} />;
    if (selectedTimeOption === 'custom') return <CustomOptionDateIcon fill={mainColor} />;
  };

  return (
    <Box sx={{ cursor: 'pointer' }} onClick={(e) => onClick(e)}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <StyledBoxIcon theme={theme} isActive={true}>
            {renderIcon()}
          </StyledBoxIcon>
          <Typography sx={{ margin: '0 6px', textTransform: 'capitalize' }}>
            {selectedTimeOption}
          </Typography>
        </Box>
        <ArrowDownIconSmall />
      </Box>
    </Box>
  );
};
